<template>
  <div class="esquerdo">
    <ul class="esquerdo">
      <li v-for="programa in programas" :key="programa.key">
        <a :href="programa.link">{{ programa.nome}}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios'
  
export default {
  data() {
    return {
      programas: []
    }
  },

  props: {
    api: String
  },

  created() {
    axios.get(this.api)
      .then( ({data}) => {
        this.programas = data
      })
  }
};
</script>



// WEBPACK FOOTER //
// src/components/RtvFooter.vue